import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAdminLoggedIn } from '../hooks/useAdminAuth';

const AdminAuthRedirect = () => {
     const isAuthenticated = isAdminLoggedIn();

     // Si está autenticado, lo redirige al dashboard de admin.
     // Si no, muestra login
     return isAuthenticated ? <Navigate to="/admin/pending-kyc-users" replace /> : <Outlet />;
};

export default AdminAuthRedirect;